import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { typographyTemplate } from '@equinor/eds-utils';
import { jsx, Fragment } from 'react/jsx-runtime';

var _excluded = ["children"];
var StyledDialogTitle = styled.div.withConfig({
  displayName: "DialogTitle__StyledDialogTitle",
  componentId: "sc-1t3jljt-0"
})(function (_ref) {
  var theme = _ref.theme,
    children = _ref.children;
  return css(["", " min-height:", ";align-self:end;justify-self:start;margin-right:", ";", ""], typographyTemplate(theme.entities.title.typography), theme.entities.title.minHeight, theme.entities.children.spacings.right, !children && css(["min-height:initial;height:'8px';"]));
});
var DialogTitle = /*#__PURE__*/forwardRef(function DialogTitle(_ref2, ref) {
  var children = _ref2.children,
    rest = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/jsx(Fragment, {
    children: /*#__PURE__*/jsx(StyledDialogTitle, _objectSpread(_objectSpread({
      id: "eds-dialog-title",
      ref: ref
    }, rest), {}, {
      children: children
    }))
  });
});

export { DialogTitle };
